export default __webpack_public_path__ + "4b00d6fcac4e53781f01c19cb6fbe535.svg";